import React from 'react';
import {connect} from 'react-redux';

import {
    CERTIFIED_BOBEUR,
    CERTIFIED_BOBEUSE
} from 'constants/memberPhoto';

import {openMemberPhoto} from 'reducers/memberPhoto';

import {t, dt} from 'l10n';

const CertifiedBlock = function ({certifiedMemberPhotos, currentUser, openMemberPhoto}) {
    if (!certifiedMemberPhotos || !certifiedMemberPhotos.length) {
        return null;
    }

    let certifiedMemberPhoto = certifiedMemberPhotos[0];

    let label;
    switch (certifiedMemberPhoto.gender) {
        case CERTIFIED_BOBEUR:
            label = t('Certified Bobeur');
            break;
        case CERTIFIED_BOBEUSE:
            label = t('Certified Bobeuse');
            break;
    }

    let onClick = currentUser.isLoggedIn() ? () => openMemberPhoto(certifiedMemberPhoto) : null;

    return (
        <div className="certifiee-block">
            <div className={'avatar' + (onClick ? ' viewable' : '')} onClick={onClick}>
                <img src={certifiedMemberPhoto.thumb_url} alt=""/>
            </div>
            <div className="b-certifiee">{label}</div>
        </div>
    )
};

export default connect(
    state => ({
        currentUser: state.currentUser
    }),
    {
        openMemberPhoto: openMemberPhoto
    }
)(CertifiedBlock)


// WEBPACK FOOTER //
// ./src/components/profile/CertifiedBlock.js